module.exports = __webpack_public_path__ + "static/media/instructions_2.ae2fa5bc.svg";